<template>
  <div class="peers ai-s fxw-nw h-100vh">
    <div class="peer peer-greed h-100 pos-r bgr-n bgpX-c bgpY-c bgsz-cv">
      <div class="pos-a centerXY">
        <div
          class="bgc-white bdrs-50p pos-r"
          style="width: 120px; height: 120px;"
        >
          <img
            class="pos-a centerXY"
            src="@/assets/img/soulhelp-logo.svg"
            alt=""
            width="120"
          />
        </div>
      </div>
    </div>

    <div
      class="col-12 col-md-4 peer pX-40 pY-80 h-100 bgc-grey-100 scrollable pos-r"
      style="min-width: 320px;"
    >
      <h4 class="fw-300 c-grey-900 mB-40">Вход</h4>

      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <the-mask
              v-model="$v.phone.$model"
              mask="+7 (###) ###-##-##"
              type="tel"
              masked
              placeholder="Введите номер телефона"
              class="form-control"
              :class="{ 'is-invalid': $v.phone.$error || formErrors.phone }"
            ></the-mask>
            <form-error :errors="formErrors" index="phone"></form-error>
          </div>
        </div>
      </div>

      <template v-if="!isPhoneChecked">
        <div class="row">
          <div class="col-12">
            <input
              type="submit"
              class="btn btn-primary"
              value="Далее"
              :disabled="isCheckPhoneButtonDisabled"
              @click="checkPhone"
            />
          </div>
        </div>
      </template>

      <div v-if="isPhoneChecked" class="pb-3">
        <template v-if="!isNewUser && !hasPassword">
          <div class="row mt-3">
            <div class="col-12">
              <div class="alert alert-warning">
                Здравствуйте, {{ firstName }}! Чтобы не поднимать стоимость
                бронирования, нам пришлось отказаться от подтверждения Вашего
                номера телефона с помощью SMS. Мы решили вернуться к
                классической схеме с паролем. На данный момент у Вас не
                уставнолен пароль. Для его установки Вам необходимо подтвердить
                Ваш номер телефона позвонив на определённый номер. Для получения
                номера нажмите, пожалуйста, на кнопку "Получить номер" и
                позвоните на полученый номер. Ваш звонок сбросится
                автоматически. Это
                <strong class="text-success">бесплатно для Вас</strong> и в
                дальнейшем мы не будем просить Вас повторять этот звонок.
              </div>
            </div>
          </div>

          <div v-if="!loadNumberState.isLoaded" class="row mt-3">
            <div class="col-12 text-center">
              <input
                type="submit"
                class="btn btn-primary"
                value="Получить номер"
                :disabled="loadNumberState.isLoading"
                @click="loadNumber"
              />
            </div>
          </div>

          <div
            v-if="loadNumberState.isLoaded && !confirmNumberState.isConfirmed"
            class="row mt-3"
          >
            <div class="col-12 text-center">
              Номер для подтверждения:<br />
              <a :href="`tel:+${loadNumberState.number}`">{{
                humanizePhone(loadNumberState.number)
              }}</a
              ><br />
              Данный номер доступен для подтвержения в течение 15-ти минут.

              <p>
                После подтверждения номера появится поле для установки пароля.
              </p>
            </div>
          </div>

          <div v-if="confirmNumberState.isConfirmed">
            <div class="row mt-3">
              <div class="col-12 text-center">
                <strong class="text-success">
                  Номер телефона подтверждён.
                </strong>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12">
                Теперь Вы можете установить пароль. Длинна пароля должна быть не
                менее 6-ти символов.
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12">
                <div class="form-group">
                  <label class="text-normal text-dark">
                    Пароль <span class="text-danger">*</span>
                  </label>

                  <input
                    v-model="password"
                    type="password"
                    name="password"
                    class="form-control"
                    Placeholder="Введите пароль"
                    required
                  />

                  <form-error :errors="formErrors" index="lastName" />
                </div>
              </div>

              <div class="col-12">
                <div class="form-group">
                  <label class="text-normal text-dark">
                    Подтвердите пароль <span class="text-danger">*</span>
                  </label>

                  <input
                    v-model="passwordConfirmation"
                    type="password"
                    name="passwordConfirmation"
                    class="form-control"
                    Placeholder="Подтвердите пароль"
                    required
                  />

                  <small v-if="passwordSet" class="text-success">
                    Пароль сохранён
                  </small>
                </div>
              </div>

              <div class="col-12 text-center">
                <input
                  type="submit"
                  class="btn btn-primary"
                  value="Сохранить пароль и продолжить"
                  :disabled="!canSetPassword"
                  @click="savePassword"
                />
              </div>
            </div>
          </div>
        </template>

        <template v-if="!isNewUser && hasPassword">
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <input
                  v-model="password"
                  type="password"
                  name="password"
                  class="form-control"
                  Placeholder="Введите пароль"
                  required
                />

                <small v-if="wrongPassword" class="text-danger">
                  Введён неправильный пароль
                </small>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <input
                type="submit"
                class="btn btn-primary"
                value="Войти"
                :disabled="!isCanLogin"
                @click="loginUser"
              />
            </div>

            <div class="col-6 text-right">
              <a href="" @click.prevent="resetPassword">Не помню пароль</a>
            </div>
          </div>
        </template>

        <template v-if="isNewUser">
          <div class="row mt-3">
            <div class="col-12">
              <div class="alert alert-warning">
                Здравствуйте! Чтобы не поднимать стоимость бронирования, нам
                пришлось отказаться от подтверждения Вашего номера телефона с
                помощью SMS. Для подтверждения номера Вам необходимо позвонить
                на определённый номер. Для получения номера нажмите, пожалуйста,
                на кнопку "Получить номер" и позвоните на полученый номер. Ваш
                звонок сбросится автоматически. Это
                <strong class="text-success">бесплатно для Вас</strong> и в
                дальнейшем мы не будем просить Вас повторять этот звонок.
              </div>
            </div>
          </div>

          <div v-if="!loadNumberState.isLoaded" class="row mt-3">
            <div class="col-12 text-center">
              <input
                type="submit"
                class="btn btn-primary"
                value="Получить номер"
                :disabled="loadNumberState.isLoading"
                @click="loadNumber"
              />
            </div>
          </div>

          <div
            v-if="loadNumberState.isLoaded && !confirmNumberState.isConfirmed"
            class="row mt-3"
          >
            <div class="col-12 text-center">
              Номер для подтверждения:<br />
              <a :href="`tel:+${loadNumberState.number}`">{{
                humanizePhone(loadNumberState.number)
              }}</a
              ><br />
              Данный номер доступен для подтвержения в течение 15-ти минут.

              <p>
                После подтверждения номера Вы сможете зарегистрироваться.
              </p>
            </div>
          </div>

          <template v-if="confirmNumberState.isConfirmed">
            <p class="mt-3">
              Привет!<br />
              Кажется Вы здесь впервые.<br />
              Прежде чем продолжить давайте познакомимся. Укажите о себе
              дополнительную информацию.<br />
              Обещаем, что в следующий раз мы не будем задавать лишних вопросов.
            </p>

            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label class="text-normal text-dark">
                    Фамилия <span class="text-danger">*</span>
                  </label>

                  <input
                    v-model="$v.lastName.$model"
                    type="text"
                    name="lastName"
                    class="form-control"
                    Placeholder="Введите Вашу фамилию"
                    required
                    :class="{
                      'is-invalid': $v.lastName.$error || formErrors.lastName
                    }"
                  />

                  <form-error :errors="formErrors" index="lastName" />
                </div>
              </div>

              <div class="col-12">
                <div class="form-group">
                  <label class="text-normal text-dark">
                    Имя <span class="text-danger">*</span>
                  </label>

                  <input
                    v-model="$v.firstName.$model"
                    type="text"
                    name="firstName"
                    class="form-control"
                    Placeholder="Введите Ваше имя"
                    required
                    :class="{
                      'is-invalid': $v.firstName.$error || formErrors.firstName
                    }"
                  />

                  <form-error :errors="formErrors" index="firstName" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label class="text-normal text-dark">
                    E-mail <span class="text-danger">*</span>
                  </label>

                  <input
                    v-model="$v.email.$model"
                    type="email"
                    name="email"
                    class="form-control"
                    Placeholder="Введите Ваш e-mail"
                    required
                    :class="{
                      'is-invalid': $v.email.$error || formErrors.email
                    }"
                  />

                  <form-error :errors="formErrors" index="email" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label class="text-normal text-dark">
                    Пароль <span class="text-danger">*</span>
                  </label>

                  <input
                    v-model="$v.password.$model"
                    type="password"
                    name="password"
                    class="form-control"
                    Placeholder="Введите пароль"
                    required
                  />

                  <form-error :errors="formErrors" index="lastName" />
                </div>
              </div>

              <div class="col-12">
                <div class="form-group">
                  <label class="text-normal text-dark">
                    Подтвердите пароль <span class="text-danger">*</span>
                  </label>

                  <input
                    v-model="$v.passwordConfirmation.$model"
                    type="password"
                    name="passwordConfirmation"
                    class="form-control"
                    Placeholder="Подтвердите пароль"
                    required
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <input
                  type="submit"
                  class="btn btn-primary"
                  value="Зарегистрироваться"
                  :disabled="!isFormFilled"
                  @click="registerUser"
                />
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { TheMask } from 'vue-the-mask';
import {
  email,
  maxLength,
  minLength,
  required,
  sameAs
} from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';

import pageLoaderService from '@/services/pageLoaderService';
import authService from '@/services/auth';

export default {
  name: 'LoginFormComponent',

  components: {
    TheMask
  },

  data() {
    return {
      //    TODO: Убрать
      phone: '',
      code: '',
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      passwordConfirmation: '',

      isNewUser: false,
      showForm: false,
      phoneChecked: false,

      hasPassword: false,
      isPhoneChecked: false,

      isTimerShown: false,
      isConfirmationCodeShown: false,

      timeBeforeNextSend: 120,
      intervalId: 0,

      oldPhone: '',

      loadNumberState: {
        isLoaded: false,
        isLoading: false,
        number: ''
      },

      confirmNumberState: {
        isLoading: false,
        isConfirmed: false,
        intervalId: null
      },

      wrongPassword: false,
      passwordSet: false,

      userData: {}
    };
  },

  computed: {
    ...mapGetters(['formErrors']),

    clearPhone() {
      return this.phone.replace(/[^0-9]/g, '');
    },

    isFormFilled() {
      return !this.$v.$invalid;
    },

    isCheckPhoneButtonDisabled() {
      return (
        this.$v.phone.$invalid || this.$v.phone.$error || this.isTimerShown
      );
    },

    canSetPassword() {
      return (
        this.password.length >= 6 && this.password === this.passwordConfirmation
      );
    },

    isCanLogin() {
      return this.password.length >= 6;
    }
  },

  watch: {
    phone(newValue) {
      if (!this.$v.phone.$error && this.oldPhone !== newValue) {
        this.oldPhone = newValue;
        clearInterval(this.intervalId);
        this.hideTimer();
        this.isConfirmationCodeShown = false;
        this.isNewUser = false;
        this.isPhoneChecked = false;

        this.loadNumberState = {
          isLoaded: false,
          isLoading: false,
          number: ''
        };

        this.confirmNumberState = {
          isLoading: false,
          isConfirmed: false,
          intervalId: null
        };

        this.wrongPassword = false;
        this.passwordSet = false;

        this.userData = {};
      }
    }
  },

  mounted() {
    pageLoaderService.hide();
  },

  validations() {
    const rules = {
      phone: {
        required,
        minLength: minLength(18),
        maxLength: maxLength(18)
      }

      /*
      code: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(4)
      }
       */
    };

    if (this.isNewUser) {
      rules.firstName = {
        required,
        minLength: minLength(2)
      };

      rules.lastName = {
        required,
        minLength: minLength(2)
      };

      rules.email = {
        required,
        minLength: minLength(4),
        email
      };

      rules.password = {
        required,
        minLength: minLength(4)
      };

      rules.passwordConfirmation = {
        sameAsPassword: sameAs('password')
      };
    }

    return rules;
  },

  methods: {
    async checkPhone() {
      this.isFormSent = true;
      const response = await authService.checkUser(this.clearPhone);

      this.isNewUser = response.isNewUser || false;
      this.hasPassword = response.hasPassword || false;
      this.firstName = response.user.firstName || '';

      // this.startTimer();
      // this.showTimer();

      this.isPhoneChecked = true;
      this.isFormSent = false;
    },

    async confirmPhone() {
      const response = await authService.verifyPhone(this.clearPhone);

      this.startTimer();
      this.showTimer();

      this.isConfirmationCodeShown = true;
      this.isNewUser = response.isNewUser;
    },

    sendForm() {
      if (this.isNewUser) {
        this.registerUser();
      } else {
        this.loginUser();
      }
    },

    startTimer() {
      const times = this.timeBeforeNextSend;
      const self = this;

      this.intervalId = setInterval(() => {
        self.timeBeforeNextSend -= 1;

        if (self.timeBeforeNextSend <= 0) {
          clearInterval(self.intervalId);
          self.timeBeforeNextSend = times;
          self.hideTimer();
        }
      }, 1000);
    },

    showTimer() {
      this.isTimerShown = true;
    },

    hideTimer() {
      this.isTimerShown = false;
    },

    async registerUser() {
      await authService.register({
        phone: this.clearPhone,
        email: this.email,
        firstName: this.firstName,
        lastName: this.lastName,
        password: this.password
      });
    },

    async loginUser() {
      this.wrongPassword = false;

      const response = await authService.login(this.clearPhone, this.password);

      if (!response) {
        this.wrongPassword = true;
      }
    },

    loadNumber() {
      this.loadNumberState.isLoaded = false;
      this.loadNumberState.isLoading = true;

      authService
        .getPhone(this.clearPhone)
        .then(getPhoneResponse => {
          this.loadNumberState.isLoaded = true;
          this.loadNumberState.isLoading = false;
          this.loadNumberState.number = getPhoneResponse.phone;

          this.confirmNumberState.isConfirmed = false;
          this.confirmNumberState.isLoading = true;
          this.confirmNumberState.intervalId = null;

          setTimeout(() => {
            this.confirmNumberState.intervalId = setInterval(() => {
              authService
                .checkPhone(this.clearPhone)
                .then(verificationResponse => {
                  if (verificationResponse.status === 1) {
                    clearInterval(this.confirmNumberState.intervalId);
                    this.confirmNumberState.intervalId = null;
                    this.confirmNumberState.isConfirmed = true;
                  }

                  if (verificationResponse.user) {
                    this.userData = {
                      user: verificationResponse.user,
                      accessToken: verificationResponse.accessToken,
                      settings: verificationResponse.settings
                    };
                  }
                })
                .finally(() => {
                  this.confirmNumberState.isLoading = false;
                });
            }, 5000);
          }, 20000);
        })
        .finally(() => {
          this.loadNumberState.isLoading = false;
        });
    },

    /**
     *
     * @param {string} phone
     * @return {string}
     */
    humanizePhone(phone) {
      const code = phone.slice(1, 4);
      const first = phone.slice(4, 7);
      const second = phone.slice(7, 9);
      const third = phone.slice(9, 11);

      return `+${phone[0]} (${code}) ${first}-${second}-${third}`;
    },

    async savePassword() {
      this.passwordSet = false;
      await authService.setPassword(this.password, this.userData.accessToken);
      this.passwordSet = true;

      await authService.saveUserInfo(this.userData);
    },

    resetPassword() {
      this.hasPassword = false;
    }
  }
};
</script>

<style scoped></style>
